import { FormAutocomplete } from 'app/components/form-autocomplete/form-autocomplete';
import { RoomSpecialRequestModel } from 'app/pages/checkout-module/checkout2/room-special-request/room-special-request.model';

export class GuestInfo {
  guests: GuestInfoV2[];
  specialRequest: RoomSpecialRequestModel;
}

export class GuestInfoModel {
  fullName: String = '';
  // Only for promotiom checkout
  firstName: String = '';
  lastName: String = '';
  email: String = '';
  guestType: String = 'AD';
  countryId: String = '0';
  nationalityId: String = 'TH';
  specialRequest: String = '';
  savingGuest?= false;
  mobileNumber: String;
  countryISO2: String;
  countryCallingCode: String;
  nationality: String = 'TH';
}

export class GuestInfoV2 {
  fullName: String = '';
  // Only for promotiom checkout
  firstName: String = '';
  lastName: String = '';
  email: String = '';
  guestType: String = 'AD';
  nationality: String = 'TH';
  savingGuest?= false;
  mobileNumber: String;
  countryISO2: String;
  countryCallingCode: String;
  specialRequest: String;

  constructor(guestInfoModel: GuestInfoModel) {
    this.fullName = guestInfoModel.fullName;
    this.firstName = guestInfoModel.firstName;
    this.lastName = guestInfoModel.lastName;
    this.email = guestInfoModel.email;
    this.guestType = guestInfoModel.guestType;
    this.nationality = guestInfoModel.nationalityId;
    this.savingGuest = guestInfoModel.savingGuest;
    this.mobileNumber = guestInfoModel.mobileNumber;
    this.countryISO2 = guestInfoModel.countryISO2;
    this.countryCallingCode = guestInfoModel.countryCallingCode;
    this.specialRequest = guestInfoModel.specialRequest;
  }
}

export class RoomModel {
  title: String;
  optionCode: String;
  adult: Number;
  child: Number;
  maxAdult: String;
  maxChild: String;
  allGuests: Number;
  selectedBedTypeEn: string;
  selectedBedTypeTh: string;
}

export class GuestDetailsDto {
  index: Number;
  room: RoomModel;
  guestInfoList: GuestInfoModel[];
  guestInfoBookerTravellerList: GuestInfoModel[] = [];
}

export class GuestDetailsPayload {
  index: Number;
  guestInfoList: GuestInfoModel[];
}


export class Traveller extends FormAutocomplete {
  userGuestID?: number;
  fullName: string;
  email: string;
  nationality: string;
  iso2: string;
  phone: string;

  constructor(fullName?: string, email?: string, nationality?: string, iso2?: string, phone?: string) {
    super();
    this.fullName = fullName;
    this.email = email;
    this.nationality = nationality;
    this.iso2 = iso2;
    this.phone = phone;
  }
}

export class BookForTraveller extends Traveller {
  userGuestId?: number;
  additionalTravellerDetails?: AdditionalTravellerDetail[];
  displayEmail = false;
  userCondition: UserCondition;
}

export class UserCondition {
  isAllowCreditTerms: boolean;
  isAllowLimitBudget: boolean;
  isAllowSendEmailApprove: boolean;
  isAllowSendEmailNotification: boolean;
  isAllowBookThisPeriod: boolean;
  isAllowBookThisDestination: boolean;
  isAllowBookAcrossMonth: boolean;
  isValidApprovalInfo: boolean;
}
export class TravellerConstants {
  public static readonly MAX_SAVE_GUEST = 50;
}

export class AddNewGuestRequest {
  userGuests: Traveller[];

  constructor(travellers: Traveller[]) {
    this.userGuests = travellers;
  }
}

export class RoomGuestIndex {
  roomIndex: string;
  guestIndex: string;

  constructor(roomIndex?: string, guestIndex?: string) {
    this.roomIndex = roomIndex;
    this.guestIndex = guestIndex;
  }
}

export class AdditionalTravellerDetail {
  fieldId: string;
  value: string;
  allowSavingData?: boolean;

  constructor(fieldId: string, value: string, allowSavingData: boolean) {
    this.fieldId = fieldId;
    this.value = value;
    this.allowSavingData = allowSavingData;
  }
}

export class OccupancyInfoDTO {
  adult: string;
  child: string;
  childAges: string;
}



// WEBPACK FOOTER //
// ./src/app/model/checkout/guest-info.model.ts